import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';

// 主题提前应用（避免刷新闪回默认主题）
document.documentElement.dataset.theme = localStorage.getItem('theme') || 'dark';

Vue.config.productionTip = false;

// 路由守卫：未登录的页面跳登录（auth 页除外）；AI 模块页允许浏览（到期只拦 AI 调用）
router.beforeEach((to, from, next) => {
  if (to.meta.public) return next();
  if (!store.state.auth.ready) {
    // 等 init 完成再判断
    const unwatch = store.watch((s) => s.auth.ready, (ready) => {
      unwatch();
      if (!ready) return next();
      if (!store.getters['auth/loggedIn']) return next(`/auth?redirect=${encodeURIComponent(to.fullPath)}`);
      next();
    }, { immediate: true });
    return;
  }
  if (!store.getters['auth/loggedIn']) return next(`/auth?redirect=${encodeURIComponent(to.fullPath)}`);
  next();
});

store.dispatch('auth/init').finally(() => {
  new Vue({ router, store, render: (h) => h(App) }).$mount('#app');
});
